import { getRobloxDomain } from '@modules/utilities/constants/baseUrl';

const downloadStudioUrl = `https://www.${getRobloxDomain()}/download/studio`;
export default downloadStudioUrl;
